import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const patchTemplateSettingMutationAtom = createMutationAtomFactory(
  'core.patchTemplateSetting',
  ({
    organizationId,
    settingId,
    fileId,
  }: {
    organizationId: string;
    settingId: string;
    fileId: string;
  }) => ({
    corePatchScopedSettingValues: {
      __args: {
        input: {
          scope: 'Organization',
          objectId: organizationId,
          values: {
            [settingId]: fileId,
          },
        },
      },
    },
  }),
);
